import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/changeApple.svg'


const _withScopeId = n => (_pushScopeId("data-v-671fcc79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("工商变更申请")
const _hoisted_4 = { class: "table-part" }
const _hoisted_5 = { class: "table-btn" }
const _hoisted_6 = ["onClick"]

import Title from "@/components/Title.vue";
import ApproveFilter from "@/components/ApproveFilter.vue";
import { CHANGES } from "@/const/openManageTableList.ts";
import { getApplyList } from "@/api/businessChange";

import { ref, reactive, computed, onActivated } from "vue";
// 获取员工信息
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const tableData = ref([]);
const pagination = reactive({
  total: 0,
  current: 1,
  defaultPageSize: 10,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "20", "30", "40"],
  showTotal: (total: number) => `共 ${total} 条数据`,
});

const router = useRouter();
const route = useRoute();

const data = reactive({
  filterForm: {
    PageIndex: pagination.current,
    PageSize: pagination.defaultPageSize,
    CompanyId: 0,
    RegionId: 0,
    Key: "",
    ChangeCodes: [],
    ApplyTimeArr: [],
  },
});
const getProcessFlowList = async () => {
  const { Data, Success, Message, Total } = await getApplyList({
    PageIndex: pagination.current,
    PageSize: pagination.pageSize,
    CompanyId: data.filterForm.CompanyId,
    RegionId: data.filterForm.RegionId,
    Key: data.filterForm.Key,
    ChangeCodes: data.filterForm.ChangeCodes,
    ApplyStartTime: data.filterForm.ApplyTimeArr
      ? data.filterForm.ApplyTimeArr[0]
      : "",
    ApplyEndTime: data.filterForm.ApplyTimeArr
      ? data.filterForm.ApplyTimeArr[1]
      : "",
  });
  if (Success) {
    tableData.value = Data;
    pagination.total = Total;
  } else {
    message.warning(Message);
  }
};

// getProcessFlowList();
// 判断页面是从相关二级页面 返回
onActivated(() => {
  if (route.meta.flag) {
    //  保留筛选条件
  } else {
    pagination.current = 1;
    pagination.pageSize = 10;
    data.filterForm = {
      PageIndex: pagination.current,
      PageSize: pagination.defaultPageSize,
      CompanyId: 0,
      RegionId: 0,
      Key: "",
      ChangeCodes: [],
      ApplyTimeArr: [],
    };
  }

  getProcessFlowList();
});
// 数据筛选
const DataSearch = (val: any) => {
  data.filterForm = val;
  pagination.current = 1;
  getProcessFlowList();
};
const handleTableChange = (row: any) => {
  pagination.current = row.current;
  pagination.pageSize = row.pageSize;
  getProcessFlowList();
};
// 跳转详情
const handleDetail = (row: any) => {
  const IsCreated = row.IsCreated;
  if (IsCreated) {
    // 当前登陆人是审批人
    router.push({
      path: "/changeProcess",
      query: {
        id: row.Id,
        traceId: row.TraceId,
        ChangeCompanyId: row.ChangeCompanyId,
      },
    });
  } else {
    router.push({
      path: "/changeProcess",
      query: {
        id: row.Id,
        traceId: row.TraceId,
        ChangeCompanyId: row.ChangeCompanyId,
        StaffId: row.StaffId,
      },
    });
  }
};
//跳转工商申请
const toChange = () => {
  router.push("/change");
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Title, { title: '工商变更' }),
      (_unref(personInfo).BusinessChangeIsShow == 1)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            size: "small",
            onClick: toChange
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ApproveFilter, {
      titleFlag: '工商变更',
      onDataSearch: DataSearch
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_table, {
        columns: _unref(CHANGES),
        "data-source": tableData.value,
        pagination: _unref(pagination),
        scroll: { x: 1000 },
        onChange: handleTableChange
      }, {
        btn: _withCtx(({ text: record }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btnClass",
              onClick: ($event: any) => (handleDetail(record))
            }, "详情", 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "pagination"])
    ])
  ], 64))
}
}

})